import { GetGlobalSearchRecentItemsUseCase } from './GetGlobalSearchRecentItemsUseCase'
import { globalSearchRecentsRepository } from '../../../data-access/repositories'

export const getGlobalSearchRecentItems = new GetGlobalSearchRecentItemsUseCase(
  {
    recentsRepository: globalSearchRecentsRepository,
  }
).execute
